import { FormControl, FormHelperText } from '@mui/material';
import React, { useCallback } from 'react';
import './editor.css';
import QuillWrapper from './QuillWrapper';

function TextEditor({
  content = '',
  handleChange = () => {},
  modules = {
    toolbar: [
      // [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ header: '1' }, { header: '2' }, { font: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ size: [] }],
      // [{ font: [] }],
      [{ align: ['right', 'center', 'justify'] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      [{ color: ['red', '#785412', '#000'] }],
      [{ background: ['red', '#785412', '#fff'] }],
    ],
  },
  formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'color',
    'image',
    'background',
    'align',
    'size',
    'font',
  ],
  error,
  helperText,
}) {
   const handleContentChange = useCallback((newContent) => {
    if (newContent === '<p><br></p>') {
      handleChange('');
    } else {
      handleChange(newContent);
    }
  }, [handleChange]);

  return (
    <>
      <FormControl
        required
        error={error}
        sx={{
          width: '100%',
        }}
        component="fieldset"
        variant="standard"
      >
        <QuillWrapper
        value={content}
        onChange={handleContentChange}
        modules={modules}
      />
        {helperText && error ? (
          <FormHelperText>{helperText}</FormHelperText>
        ) : null}
      </FormControl>
    </>
  );
}

export default TextEditor;
